import { JourneyRoutes } from "@common/models/enums";
import { Conditional, DescriptionListItem } from "@components/fields";
import { BRAND_OPTIONS, ManufacturerKey } from "@product-pages/model/options/brand";
import { CAR_OPTIONS, CarOptionsKey } from "@product-pages/model/options/car-type";
import { WIZARD_FORM_FIELDS } from "@product-pages/model/wizard-form-fields";
import { mapVehicleData } from "@products/necst-ratenkredit/model/mapper";
import { carType } from "@products/necst-ratenkredit/model/types";
import { saveVehicleData } from "@services/api/vehicleData";
import { Button, ButtonContainer, ContentSection, DataOverview, DescriptionList, Heading, Paragraph, Spinner } from "@vwfs-bronson/bronson-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { resolvePath, useNavigate } from "react-router-dom";

export const LandingSummary = ({ setShowCarSectionForm, values }: any) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const onClick = async () => {
    setIsLoading(true);
    try {
      const response = await saveVehicleData(mapVehicleData(values));
      window.location.href = response.redirectUrl;
    } catch {
      navigate(resolvePath(JourneyRoutes.ERROR));
    } finally {
      setIsLoading(false)
    }
  };
  const manufacturerFormatter = (value?: any) => value ? BRAND_OPTIONS?.[value as ManufacturerKey] : '';
  const isUsedFormatter = (value?: any) => value ? CAR_OPTIONS?.[value as CarOptionsKey] : '';

  return (
    <>
      <Spinner fullPage busy={isLoading} />
      <ContentSection className="u-pb-none">
        <Heading>{t("landing:vehicleSection:summarySection:title")}</Heading>
        <Paragraph>{t("landing:vehicleSection:summarySection:subtitle")}</Paragraph>
      </ContentSection>
      <DataOverview
        icon="semantic-checkmark"
        href="#"
        onClick={(e) => {
          e.preventDefault();
        }}
        title={t("landing:vehicleSection:title")}
        titleLevel={2}
        buttonLabel={t("landing:vehicleSection:summarySection:editButton")}
        buttonProps={{
          onClick: () => {
            setShowCarSectionForm(true)
          },
        }}
        className="u-mb"
      >
        <DescriptionList grid>
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:brand:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.manufacturer()}
            formatter={manufacturerFormatter}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:modelShort:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.name()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:modelLong:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.descriptionLong()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:year:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.year()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:priceList:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.recommendedRetailPriceAmount.amount()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:price:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.retailPriceAmount.amount()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:usedCar:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.isUsed()}
            formatter={isUsedFormatter}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:deliveryDate:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.deliveryData.deliveryDate()}
          />
          <Conditional
            when={WIZARD_FORM_FIELDS.vehicleData.isUsed()}
            is={(isUsed) => isUsed === carType.USED}
          >
            <DescriptionListItem
              termText={t("landing:vehicleSection:fields:vin:label")}
              formField={WIZARD_FORM_FIELDS.vehicleData.vin()}
            />
          </Conditional>
          <Conditional
            when={WIZARD_FORM_FIELDS.vehicleData.isUsed()}
            is={(isUsed) => isUsed === carType.USED}
          >
            <DescriptionListItem
              termText={t("landing:vehicleSection:fields:firstRegistrationDate:label")}
              formField={WIZARD_FORM_FIELDS.vehicleData.initialRegistrationDate()}
            />
          </Conditional>
          <Conditional
            when={WIZARD_FORM_FIELDS.vehicleData.isUsed()}
            is={(isUsed) => isUsed === carType.USED}
          >
            <DescriptionListItem
              termText={t("landing:vehicleSection:fields:mileage:label")}
              formField={WIZARD_FORM_FIELDS.vehicleData.odometer()}
            />
          </Conditional>
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:orderDate:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.orderDate()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:manufacturerKeyNumber:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.manufacturerCode()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:typeKeyNumber:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.typeCode()}
          />
          <DescriptionListItem
            termText={t("landing:vehicleSection:fields:modelTypeKey:label")}
            formField={WIZARD_FORM_FIELDS.vehicleData.model.code()}
          />
        </DescriptionList>
      </DataOverview>
      <ButtonContainer right>
        <Button
          type="submit"
          onClick={onClick}
        >{t("landing:vehicleSection:summarySection:submitButton")}
        </Button>
      </ButtonContainer>
    </>
  );
};
